import React from 'react'
import PropTypes from 'prop-types'
import Scheduling from './Scheduling'
import SocialLinks from './SocialLinks'
import ApptTypeSelector from './ApptTypeSelector'
import ActiveSettings from './ActiveSettings'
import './styles.css'

const SettingsOptions = ({
  emailsActive,
  handleActiveToggle,
  isLoaded,
  reviewsOffset,
  textsActive,
  tier,
  updateSetting,
  usedAppointmentTypeIds,
}) => (
  <div className="reviewsOptions">
    <div>
      <Scheduling
        isLoaded={isLoaded}
        reviewsOffset={reviewsOffset}
        updateSetting={updateSetting}
      />
      <ApptTypeSelector
        updateSetting={updateSetting}
        usedAppointmentTypeIds={usedAppointmentTypeIds}
      />
    </div>
    <ActiveSettings
      textsActive={textsActive}
      emailsActive={emailsActive}
      handleActiveToggle={handleActiveToggle}
      tier={tier}
    />
    <SocialLinks />
  </div>
)


SettingsOptions.propTypes = {
  emailsActive: PropTypes.bool.isRequired,
  handleActiveToggle: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  reviewsOffset: PropTypes.number.isRequired,
  textsActive: PropTypes.bool.isRequired,
  tier: PropTypes.number.isRequired,
  usedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateSetting: PropTypes.func.isRequired,
}

export default SettingsOptions



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/SettingsOptions.js